<div class="horizontal-container vertical-align">
    <notice-type-colour [colour]="noticeType?.colour"></notice-type-colour>
    {{ noticeType?.name || '-' }}
</div>
